<template>
    <AtomButtonArrowRight :to="to">
        {{ $t('home.explore') }}
    </AtomButtonArrowRight>
</template>
<script>
import AtomButtonArrowRight from "./AtomButtonArrowRight.vue";

export default {
    name: 'AtomButtonExplore',
    components: {AtomButtonArrowRight},
    props: {
        to: {
            String,
            required: true,
        }
    }
}
</script>
